'use client';

import { Product } from 'shared/types/product/Product';
import CtaProduct, { CtaProductProps } from 'components/padi-ui/cta-product';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';

const CtaProductTastic = ({ data }: TasticProps<DataSource<{ product: Product }> & CtaProductProps>) => {
  if (!data?.data?.dataSource?.product) return null;

  return (
    <CtaProduct
      product={data?.data?.dataSource.product}
      listBtn={data?.listBtn}
      alignment={data?.alignment}
      bgColor={data?.bgColor}
      sectionId={data?.sectionId}
    />
  );
};

export default CtaProductTastic;
